<tabset>
  <tab heading="Personeelslijst" (selectTab)="actieveTab = 'personeel'">
    <datatable2 #personeeltabel [definition]="tableDefinition" [data]="tableData" stickyheaders (rijklik)="edit($event.id)"></datatable2>
  </tab>
  <tab heading="Functies en certificaten" (selectTab)="actieveTab = 'certificaten'">
    <datatable2 #certificaattabel class="certificatenlijst verticaalfilter" [definition]="certificaatDefinition" [data]="certificaatData" stickyheaders (rijklik)="edit($event.persoon.id)"></datatable2>
  </tab>
</tabset>
<!-- één footer: teller en export volgen de actieve tab -->
@let tabel = actieveTab === 'certificaten' ? certificaattabel : personeeltabel;
<div class="footer">
  <div links>{{ tabel.filterRijen }} / {{ tabel.rijen }} &nbsp;
    <xls-datatable [datatable]="tabel" btnclass="btn btn-primary"
                   [filenaam]="actieveTab === 'certificaten' ? 'Functies en certificaten' : 'Personeel'"
                   [werkblad]="actieveTab === 'certificaten' ? 'Functies en certificaten' : 'Personeel'"></xls-datatable>
  </div>
  <div rechts>
    @if (api.can('personeelinhuur', 'full')) {
      <button class="btn btn-success" (click)="nieuw()">Nieuw...</button>
    }
  </div>
</div>
